"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Loader_1 = require("./Loader");
exports.default = Loader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Loader/index.js
// module id = 197
// module chunks = 8